import { Sidebar } from 'primereact/sidebar';

const SfSidebar = (props) => {
  const classes = props.styling ? props.styling : "";

  return <Sidebar {...props} className={classes} />;
};

export default SfSidebar;
